import { useEffect, useRef, useState } from 'react';
import './AboutSection.css';

export default function AboutSection() {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const currentRef = sectionRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.25 }
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    return (
        <section
            className={`about-section ${isVisible ? 'visible' : ''}`}
            ref={sectionRef}
            id="about"
        >
            <div className="about-wrapper">
                <div className="about-text-block">
                    <p className="about-badge">À propos de Kyra Renov</p>

                    <h2 className="about-title">
                        Une entreprise engagée pour des rénovations
                        <span> élégantes, durables et soignées</span>
                    </h2>

                    <p className="about-description">
                        Chez <strong>Kyra Renov</strong>, nous accompagnons les particuliers
                        et les professionnels dans leurs projets de
                        <strong> rénovation intérieure et extérieur</strong> avec une approche sérieuse,
                        précise et esthétique.
                    </p>

                    <p className="about-description">
                        Notre objectif est simple : transformer vos espaces avec des
                        solutions adaptées à vos envies, à vos contraintes et à votre
                        budget, tout en garantissant des
                        <strong> finitions propres</strong>, un
                        <strong> suivi rigoureux</strong> et une vraie attention portée aux
                        détails.
                    </p>

                    <p className="about-description">
                        De la préparation du chantier jusqu’aux dernières finitions, nous
                        mettons en avant le <strong>professionnalisme</strong>, la
                        <strong> réactivité</strong> et la
                        <strong> qualité d’exécution</strong> pour livrer des espaces plus
                        fonctionnels, plus modernes et plus agréables à vivre.
                    </p>

                    <div className="about-features">
                        <div className="about-feature-card">
                            <h3>Travail soigné</h3>
                            <p>Un rendu propre, harmonieux et durable dans chaque pièce.</p>
                        </div>

                        <div className="about-feature-card">
                            <h3>Suivi sérieux</h3>
                            <p>Un accompagnement clair à chaque étape de votre projet.</p>
                        </div>

                        <div className="about-feature-card">
                            <h3>Solutions sur mesure</h3>
                            <p>Des rénovations pensées selon vos besoins réels.</p>
                        </div>
                    </div>
                </div>

                <div className="about-visual">
                    <div className="about-image-card">
                        <img
                            src="/images/logo-kyra.png"
                            alt="Logo Kyra Renov"
                            className="about-floating-logo"
                        />
                    </div>

                    <div className="about-mini-card about-mini-card-top">
                        <span>Finitions premium</span>
                    </div>

                    <div className="about-mini-card about-mini-card-bottom">
                        <span>Rénovation intérieure</span>
                    </div>
                </div>
            </div>
        </section>
    );
}